import store from '@/store'

export default {
  dashboardGuard: next => {
    store.dispatch('getCurrentSession', 'user').then(session => {
      if (session) {
        store.dispatch('firstFetchInter').then(() => {
          store.dispatch('fetchDocuments').then(() => next())
        })
      } else {
        next({ name: 'userSignIn' })
      }
    })
  },
  reportGuard: (to, next) => {
    let inter = store.getters[`${store.$appName}/allInterventions`].find(inter => inter.id === parseInt(to.params.id))
    let report = inter.report
    if (report || to.params.reportId === 'new') {
      next()
    } else {
      next({ name: 'interventions' })
    }
  }
}
